import Grid from '@material-ui/core/Grid'
import { useMount } from 'ahooks'
import DatePicker from 'Components/DatePicker'
import Input from 'Components/Input'
import Search from 'Components/Search'
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import React, { useState } from 'react'

export default React.memo(props => <Search limit={100} all raz={true} defaultSearch={props.defaultSearch} group_by={props.group_by}
    path={'commun'} requete={Constants.donnee.requete} module={Constants.module.COMMUN}
    search={props.search || ((props.searchName || 'api_historique_') + (props.name || '') + User.Entite.get().id)}>
    <SearchForm />
</Search>
)

const SearchForm = React.memo(props => {
    const [search, setSearch] = useState(props.search || {})
    const searching = (data, name) => {
        const srh = {
            ...(search || {}),
            [name]: data
        }
        setSearch(srh)
        props.searching && props.searching(srh)
    }

    useMount(() => {

    })

    return (
        <Grid container spacing={0} style={{ margin: 0, padding: 5 }} justify={'flex-start'}
            alignItems={'stretch'}
            alignContent={'flex-start'}
            direction={'column'}>
            <DatePicker value={search['|date_creation']}
                range
                title={EurestoI18n.t('commun:Date de création')}
                onChange={searching}
                name={'|date_creation'} />
            <Input value={search.path} name={'path'} onChange={searching} title={'Path'} />
            <Input value={search.requete} name={'requete'} onChange={searching} title={'Requete'} />
            <Input value={search.action} name={'action'} onChange={searching} title={'Action'} />
        </Grid>
    )
})


// WEBPACK FOOTER //
// ./app/App/Module/Api/Component/Search/index.js